import { memo } from 'react';

function TaskListIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#8E33FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7.5 5h9.167M3.167 4.832l.666.667L5.5 3.832M3.167 9.832l.666.667L5.5 8.832M3.167 14.832l.666.667L5.5 13.832M7.5 10h9.167M7.5 15h9.167"
      ></path>
    </svg>
  );
}

export default memo(TaskListIcon);
